import React, {useCallback, useEffect} from 'react';
import DatePicker from "../../DatePicker/DatePicker";
import DateFilter from "../../../grids/filters/date";
import TextFilter from "../../../grids/filters/text";
import SelectFilter from "../../../grids/filters/select";
import NumberFilter from "../../../grids/filters/number";
import {unitName} from "../../../grids/utils";

const Filter = ({disabled, value, onChange, column, filterParams, isGrid, isDictionary}) => {
    const filterType = (col) => {
        switch (col.filterType) {
            case 'date':
                return <DatePicker
                    disabled={disabled}
                    hideCalendarIcon
                    compact
                    clearable
                    name={column.fieldName}
                    dateFormat='dd.MM.yyyy'
                    placeholderText={column.title}
                    value={value}
                    onChange={(e, {value}) => onChange(column.fieldName, value)}
                    maxDate={filterParams.to}
                    minDate={filterParams.from}
                />
        }
    }

    const filterTypeGrid = (col) => {
        switch (col.filterType) {
            case 'date':
                return <DateFilter
                    withSort={!column.disableSort}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'text':
                return <TextFilter
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'number':
                return <TextFilter
                    type='number'
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'select':
                return <SelectFilter
                    filterParams={filterParams}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                    isDictionary={isDictionary}
                />
            case 'selectMultiple':
                return <SelectFilter
                    filterParams={filterParams}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                    multiple
                    isDictionary={isDictionary}
                />
            case 'status':
                return <SelectFilter
                    filterParams={filterParams}
                    isStatus
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'numberRange':
                return <NumberFilter
                    unit={unitName(column.fieldName)}
                    filterParams={filterParams}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            default:
                return null
        }
    }

    return (
        isGrid
            ? <div className='grid-filter field filter-input ultra-compact'>
                {filterTypeGrid(column)}
                <div className='sizer'>{column.title}</div>
            </div>
            : filterType(column)
    );
};

export default Filter;


// WEBPACK FOOTER //
// ./App/components/Table/components/Filter.jsx